import { ReactNode } from 'react';
import cs from 'classnames';
import { useStyles } from '../../style';

interface CellProps {
  text: string | ReactNode;
  align?: 'left' | 'right';
}

const BaseHeader = ({ text, align = 'left' }: CellProps) => {
  const classes = useStyles({});

  return (
    <div
      className={cs(classes.baseHeader, {
        [classes.rightAlign]: align === 'right',
      })}>
      {text}
    </div>
  );
};

export default BaseHeader;
